export class ChannelCTADto {
}
export class MessageTemplateDto {
}
